import { getProperty } from '../../modules/ajio-util/properties';

const identifierKeys = {
  EMAIL: 'emailId',
  MOBILE: 'mobileNumber'
};

const tncLink = 'https://www.ajio.com/help/termsAndCondition';
const privacyPolicyLink = 'https://www.ajio.com/privacypolicy';

const ajioLogoSrc = `${getProperty('imageBaseUrl')}/static/img/ajio.png`;
const fbLogoSrc = `${getProperty('imageBaseUrl')}/static/img/fb.png`;
const googleLogoSrc = `${getProperty('imageBaseUrl')}/static/img/google.png`;
const authHeaderBgSrc = `${getProperty('imageBaseUrl')}/static/img/refresh-auth-bg-2.svg`;
const parentUrl = `${getProperty('parentUrl')}/`;

const setPwdPageAction = 'set';
const resetPwdPageAction = 'reset';
const setPwdOtpPageAction = 'set-password';
const resetPwdOtpPageAction = 'reset-password';

const loginUrl = '/login';
const signUpUrl = '/signup';
const loginOtpUrl = '/login/otp';
const signUpOtpUrl = '/signup/otp';
const signUpMobileUrl = '/signup/mobile';
const loginPasswordUrl = '/login/password';
const resetPasswordUrl = `/auth/password/${resetPwdPageAction}`;
const setPasswordUrl = `/auth/password/${setPwdPageAction}`;
const setPasswordOtpUrl = `/auth/otp/${setPwdOtpPageAction}`;
const resetPasswordOtpUrl = `/auth/otp/${resetPwdOtpPageAction}`;
const havingTroubleUrl = '/auth/having-trouble';
const customerSupportUrl = '/selfcare';

const resendOtpBufferTime = 60;

const genderOptions = [
  {
    label: 'Male',
    value: 'M'
  },
  {
    label: 'Female',
    value: 'F'
  }
];

const genderOptionsFruadFlow = [
  {
    label: 'Male',
    value: 'M'
  },
  {
    label: 'Female',
    value: 'F'
  },
  {
    label: 'Others',
    value: 'O'
  }
];

const passwordStrengthTags = [
  {
    label: '8+ Character',
    value: 'min8Chars'
  },
  {
    label: '# Special ',
    value: 'specialChars'
  },
  {
    label: 'A Uppercase',
    value: 'uppercase'
  },
  {
    label: '1 Number',
    value: 'numeric'
  }
];

const authReferralMessages = {
  loginOrSignup: 'Login or Signup',
  referralInvite: '__NAME__ has invited you!',
  referralBonus: 'Signup to get ₹__INCENTIVE__ AJIO Points'
};

const POST_ACC_CHK_KEY = 'P_ACT_CHK';
const YOLO_AUTH_DETAILS_KEY = 'yolo_auth_details';

export {
  identifierKeys,
  tncLink,
  privacyPolicyLink,
  ajioLogoSrc,
  parentUrl,
  signUpUrl,
  loginOtpUrl,
  loginUrl,
  signUpOtpUrl,
  signUpMobileUrl,
  loginPasswordUrl,
  resendOtpBufferTime,
  fbLogoSrc,
  googleLogoSrc,
  genderOptions,
  passwordStrengthTags,
  resetPasswordUrl,
  setPasswordUrl,
  customerSupportUrl,
  authHeaderBgSrc,
  havingTroubleUrl,
  authReferralMessages,
  setPwdPageAction,
  resetPwdPageAction,
  setPasswordOtpUrl,
  resetPasswordOtpUrl,
  setPwdOtpPageAction,
  resetPwdOtpPageAction,
  POST_ACC_CHK_KEY,
  YOLO_AUTH_DETAILS_KEY,
  genderOptionsFruadFlow
};
